<template>
  <div
    class="lego-date-picker lego-input"
    :class="datePickerClass"
    v-picker-click-outside="onClickOutside"
  >
    <lego-text-field
      ref="from-text"
      class="lego-date-picker__text-field"
      v-model="from.textInput"
      :mask="inputType.replace(/#/g, '%#').replace(/[ymd]/gi, '#')"
      :placeholder="noPlaceholder ? '' : inputType.toUpperCase()"
      :disabled="disabled"
      :readonly="readonly"
      :no-shake="noShake"
      @blur="validateFromInput"
      @focus="onFocus(1)"
      @enter="onUpdate(1)"
      @keydown.tab="(e) => onUpdate(1, e)"
      @keydown="onKeyDown"
    /><!--
     -->
    <lego-icon-wrapper
      v-if="!disableDateIcon && !readonly"
      :class="['lego-date-picker__icon-wrapper', { 'disabled-date__icon': !!disabled }]"
      @click.stop="onClickIcon(1)"
    >
      <lego-icon class="lego-date-picker__icon" icon="calendar" icon-type="df" size="16" />
    </lego-icon-wrapper>
    <template v-if="range || strictRange">
      <lego-icon-wrapper> ~</lego-icon-wrapper>
      <lego-text-field
        ref="to-text"
        class="lego-date-picker__text-field"
        v-model="to.textInput"
        :mask="inputType.replace(/#/g, '%#').replace(/[ymd]/gi, '#')"
        :placeholder="noPlaceholder ? '' : inputType.toUpperCase()"
        :disabled="disabled"
        :readonly="readonly"
        :no-shake="noShake"
        @blur="validateToInput"
        tabindex="-1"
        @focus="onFocus(2)"
        @enter="onUpdate(2)"
        @keydown.tab="(e) => onUpdate(2, e)"
        @keydown="onKeyDown"
      />
      <lego-icon-wrapper
        v-if="!disableDateIcon && !readonly"
        :class="['lego-date-picker__icon-wrapper', { 'disabled-date__icon': !!disabled }]"
        @click.stop="onClickIcon(2)"
      >
        <lego-icon class="lego-date-picker__icon" icon="calendar" icon-type="df" size="16" />
      </lego-icon-wrapper>
    </template>
    <lego-segment-wrapper
      v-if="preset.length > 0"
      v-model="presetName"
      v-bind="setSegmentWrapperBind"
      class="lego-date-picker__segment-wrapper"
    >
      <template v-for="(item, idx) in preset" :key="idx">
        <lego-segment-button :value="item.action" @click.stop="onClickSegment(item.action)"
          ><!--
                     -->{{ item.label
          }}<!--
                 --></lego-segment-button
        >
      </template>
    </lego-segment-wrapper>

    <div
      v-if="messageShow"
      class="lego-date-picker__message lego-validator__message"
      :class="messageClass"
    >
      <!--glue
        -->{{ messageShow
      }}<!--glue
     -->
    </div>
    <div
      class="lego-date-picker__calendar"
      :class="calendarClass"
      ref="calanderSelector"
      v-show="showFlag"
    >
      <div class="lego-date-picker__calendar__month-area">
        <lego-icon-wrapper @click.stop="onClickPrevMonth">
          <lego-icon icon-type="df" icon="arrow_down" :size="16" />
        </lego-icon-wrapper>
        <div class="lego-date-picker-header">
          <span
            class="lego-date-picker-type"
            @click="modeChange('year')"
            v-show="viewMode === 'day'"
          >
            {{ yearFilterFirst }}
          </span>
          <span
            class="lego-date-picker-type"
            @click="modeChange('month')"
            v-show="viewMode === 'day'"
          >
            {{ monthFilterFirst }}
          </span>
          <span
            class="lego-date-picker-type"
            @click="modeChange('year')"
            v-show="viewMode === 'month'"
          >
            {{ monthFilterFirst }}
          </span>
          <span
            class="lego-date-picker-type"
            @click="year ? modeChange('year') : month ? modeChange('month') : modeChange('day')"
            v-show="viewMode === 'year'"
          >
            {{ monthFilterFirst }}
          </span>
        </div>

        <lego-icon-wrapper @click.stop="onClickNextMonth">
          <lego-icon icon-type="df" icon="arrow_up" :size="16" />
        </lego-icon-wrapper>
      </div>

      <div v-if="viewMode === 'year'" class="lego-date-picker__calendar__date-area">
        <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverYear = ''">
          <template v-for="(years, didx) in decadeCalendar(calendarMonth)" :key="didx">
            <div class="lego-date-picker__calendar__year__row">
              <div class="lego-date-picker__calendar__year__row-content">
                <template v-for="(year, yidx) in years" :key="yidx">
                  <span
                    :class="yearClass(year)"
                    @click.stop="onClickYear(year)"
                    @mouseenter="hoverYear = year"
                    >{{ year }}</span
                  >
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div v-if="viewMode === 'month'" class="lego-date-picker__calendar__date-area">
        <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverMonth = ''">
          <div
            v-for="(months, yidx) in yearCalendar()"
            :key="yidx"
            class="lego-date-picker__calendar__month__row"
          >
            <div class="lego-date-picker__calendar__month__row-content">
              <template v-for="(month, midx) in months" :key="midx">
                <span
                  :class="monthClass(month)"
                  @click.stop="onClickMonth(month)"
                  @mouseenter="hoverMonth = month"
                  >{{ monthAbbr[month - 1] }}</span
                >
              </template>
            </div>
          </div>
        </div>
      </div>

      <div v-if="viewMode === 'day'" class="lego-date-picker__calendar__range-container">
        <div class="lego-date-picker__calendar__date-area">
          <div class="lego-date-picker__calendar__day lego-date-picker__calendar__row">
            <div class="lego-date-picker__calendar__row-background"></div>
            <div class="lego-date-picker__calendar__row-content">
              <template v-for="(day, idx) in weekDay" :key="idx">
                <span :class="weekDayClass(idx)">{{ day.text }}</span>
              </template>
            </div>
          </div>
          <div class="lego-date-picker__calendar__date-wrapper" @mouseleave="hoverDate = ''">
            <template v-for="(week, wIdx) in daysOfMonth" :key="wIdx">
              <div class="lego-date-picker__calendar__week lego-date-picker__calendar__row">
                <div class="lego-date-picker__calendar__row-background">
                  <template v-for="(date, dIdx) in week" :key="dIdx">
                    <div :class="date.rangeColor"></div>
                  </template>
                </div>
                <div class="lego-date-picker__calendar__row-content">
                  <template v-for="(date, dIdx) in week" :key="dIdx">
                    <span
                      :class="dateClass(date, dIdx)"
                      @click.stop="onClickDate(date)"
                      @mouseenter="hoverDate = date.value"
                      >{{ date.text }}</span
                    >
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DUMMY_EVENT = {
  preventDefault: () => {}
};

import i18nMixin from '@/mixins/i18n.mixin.js';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import moment from 'moment';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';

const { dateFormat } = useDateTimeFormat();

export default {
  name: 'lego-date-picker',
  props: {
    todayText: {
      type: String,
      default: null
    },
    confirmText: {
      type: String,
      default: null
    },
    month: {
      type: Boolean,
      default: false
    },
    year: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: dateFormat
      // validator: val => {
      //   return (
      //     /^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(val) &&
      //     val.match(/y{1,4}/gi).length === 1 &&
      //     val.match(/m{1,2}/gi).length === 1 &&
      //     val.match(/d{1,2}/gi).length === 1
      //   );
      // },
    },
    modelType: {
      type: String,
      default: 'YYYY-MM-DD'
      // validator: val => {
      //   if (/^(date|array)$/i.test(val)) {
      //     return true;
      //   }
      //   return (
      //     /^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(val) &&
      //     val.match(/y{1,4}/gi).length === 1 &&
      //     val.match(/m{1,2}/gi).length === 1 &&
      //     val.match(/d{1,2}/gi).length === 1
      //   );
      // },
    },
    readonly: { type: Boolean, default: false },
    hideDateIcon: {
      type: Boolean,
      default: true
    },
    requiredDateValue: {
      type: Boolean,
      default: false
    },
    editable: { type: Boolean, default: true },
    minDate: { type: Date, default: null },
    maxDate: { type: Date, default: null },
    messageStyle: {
      type: String,
      validator: function (value) {
        return ['heavy', 'light', 'light-one-line', 'heavy-one-line'].indexOf(value) !== -1;
      },
      default: 'light'
    }
  },
  mixins: [i18nMixin],
  data() {
    return {
      default: {
        size: 'medium'
      },
      viewMode: 'day',
      weekDay: [
        { text: 'S', value: 'SUN' },
        { text: 'M', value: 'MON' },
        { text: 'T', value: 'TUE' },
        { text: 'W', value: 'WED' },
        { text: 'T', value: 'THU' },
        { text: 'F', value: 'FRI' },
        { text: 'S', value: 'SAT' }
      ],
      hoverMonth: '',
      hoverYear: '',
      showFlag: 0,
      isSetCalender: true,
      isDateSelected: false
    };
  },
  mounted() {
    if (this.month) {
      this.viewMode = 'month';
    }
    if (this.year) {
      this.viewMode = 'year';
    }
    this.$refs.calanderSelector.addEventListener('mousedown', () => (this.isDateSelected = true));
  },
  watch: {
    modelValue: {
      immediate: true,
      deep: true,
      handler(value) {
        // from.actualDate & to.actualDate only controlled by this handler. they must be equal to v-model
        if (!this.today) {
          this.currTime = new Date();
          this.today = this.dateToYmd(this.currTime);
        }
        let rtn, targetMonth, validVal;
        if (this.isRange) {
          validVal = this.toValidRange(value);
          if (this.from.actualDate !== validVal[0] || this.from.selected !== validVal[0]) {
            this.from.actualDate = validVal[0];
            this.from.textInput = this.ymdToText(
              this.from.actualDate,
              this.inputType.replace(/[^ymd]/gi, '')
            );
            this.from.selected = validVal[0];
          }
          if (this.to.actualDate !== validVal[1] || this.to.selected !== validVal[1]) {
            this.to.actualDate = validVal[1];
            this.to.textInput = this.ymdToText(
              this.to.actualDate,
              this.inputType.replace(/[^ymd]/gi, '')
            );
            this.to.selected = validVal[1];
          }
          if (validVal[1]) {
            targetMonth = validVal[1].split('-');
            // targetMonth[1] = parseInt(targetMonth[1]) - 1;
            targetMonth[1] = parseInt(targetMonth[1]);
          } else if (validVal[0]) {
            targetMonth = validVal[0].split('-');
          }

          if (!this.isEqualArray(this.presetVal, validVal)) this.presetName = '';
          rtn = [this.ymdToModel(validVal[0]), this.ymdToModel(validVal[1])];
          if (!this.isEqualArray(value, rtn)) {
            // ~documentation~
            // $ver: v0.1.2
            // $arg: updated v-model value
            // v-model을 업데이트하기 위한 이벤트
            // #Event to update v-model
            this.$emit('update:modelValue', rtn);
          } else if (this.isMounted) {
            this.validateOnEvent();
          }
        } else {
          validVal = this.modelToYmd(value);
          validVal = this.toValidYmd(validVal);
          if (this.from.actualDate !== validVal) {
            this.from.actualDate = validVal;
            this.from.textInput = this.ymdToText(
              this.from.actualDate,
              this.inputType.replace(/[^ymd]/gi, '')
            );
            this.from.selected = validVal;
          }

          if (validVal) {
            targetMonth = validVal.split('-');
          }

          if (this.presetVal !== validVal) this.presetName = '';
          rtn = this.ymdToModel(validVal);
          if (!this.isEqualModel(value, rtn)) {
            this.$emit('update:modelValue', rtn);
          } else if (this.isMounted) {
            this.validateOnEvent();
          }
        }
        if (!targetMonth) {
          let date = this.today;
          if (date < this.minDate) {
            date = this.minDate;
          }
          if (date > this.maxDate) {
            date = this.maxDate;
          }
          targetMonth = date.split('-');
        }
        if (this.isSetCalender) {
          this.setCalendarMonth([parseInt(targetMonth[0]), parseInt(targetMonth[1])]);
        } else {
          this.isSetCalender = true;
        }
      }
    },

    showFlag(newFlag) {
      let tmp;
      if (newFlag === 1) {
        if (this.isRange) {
          // this.to.textInput = '';
          // this.to.selected = '';
        }
        if (this.from.selected) {
          tmp = this.from.selected;
        } else {
          tmp =
            this.today < this.minDate
              ? this.minDate
              : this.today > this.maxDate
              ? this.maxDate
              : this.today;
        }
        tmp = tmp.split('-');
        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
      } else if (newFlag === 2) {
        if (this.to.selected) {
          tmp = this.dateToYmd(this.ymdToDate(this.to.selected, 0, 0, 0));
        } else if (this.from.selected) {
          tmp = this.from.selected;
        } else {
          tmp =
            this.today < this.minDate
              ? this.minDate
              : this.today > this.maxDate
              ? this.maxDate
              : this.today;
        }
        tmp = tmp.split('-');
        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
      }
    }
  },
  computed: {
    daysOfMonth() {
      const month = this.monthCalendar(this.calendarMonth, 1);
      if (!this.minDate && !this.maxDate) return month;
      for (const week of month) {
        for (const day of week) {
          const { value } = day;
          const date = moment(value, 'YYYY-MM-DD');
          if (this.minDate && date.isBefore(this.minDate)) day.state = 'disabled';
          if (this.maxDate && date.isAfter(this.maxDate)) day.state = 'disabled';
        }
      }
      return month;
    },
    disableDateIcon() {
      return this.disabled && this.hideDateIcon;
    },

    monthFilterFirst() {
      switch (this.viewMode) {
        case 'day':
          return this.monthAbbr[parseInt(this.calendarMonth[1]) - 2 + 1];
        case 'month':
          return this.monthFilter(this.calendarMonth, 1);
        case 'year':
          return this.monthFilter(this.calendarMonth, 1);
        default:
          break;
      }
      return false;
    },

    yearFilterFirst() {
      switch (this.viewMode) {
        case 'day':
          return this.calendarMonth[0];
        case 'month':
          return this.monthFilter(this.calendarMonth, 1);
        case 'year':
          return this.monthFilter(this.calendarMonth, 1);
        default:
          break;
      }
      return false;
    }
  },
  methods: {
    onKeyDown(e) {
      if (this.editable) return true;
      e.preventDefault();
      return false;
    },
    onFocus(idx) {
      if (idx === 2 && this.strictRange && !this.from.selected) {
        this.$refs['from-text'].focus();
        return;
      }
      if (!this.editable) {
        this.$refs['from-text'].blur();
        if (this.$refs['to-text']) this.$refs['to-text'].blur();
      }
      this.showFlag = idx;
    },

    onClickIcon(idx) {
      legoEventBus.$emit('click-outside');
      if (this.disabled) return;
      this.showFlag = this.showFlag === idx ? 0 : idx;
      this.$emit('show-calendar');
    },

    offFlag() {
      this.showFlag = 0;
    },

    inputToYmd(input) {
      if (!input || typeof input !== 'string') {
        return '';
      }
      let inputFormat = this.inputType.replace(/[^ymd]/gi, '').toUpperCase();
      let sIdx = inputFormat.indexOf('Y');
      let y4Flag = inputFormat.indexOf('YYYY') !== -1;
      let YYYY = '',
        tmp = '';
      if (input.length === 4) {
        // no YYYY or YY
        if (y4Flag) {
          YYYY = input;
          if (this.viewMode === 'month') {
            tmp = YYYY + '01';
          } else if (this.viewMode === 'year') {
            tmp = YYYY;
          } else {
            tmp = YYYY + '0101';
          }
        } else {
          tmp = input.slice(0, sIdx) + YYYY.slice(2) + input.slice(sIdx);
        }
      } else if (input.length === 6) {
        // YY
        if (y4Flag) {
          // YYYY = input.slice(sIdx, sIdx + 2);
          // YYYY = parseInt(YYYY) < 70 ? '20' + YYYY : '19' + YYYY;
          YYYY = input.slice(sIdx, sIdx + 4);
          if (this.viewMode === 'month') {
            tmp = YYYY + input.slice(4);
          } else {
            tmp = YYYY + input.slice(4) + '01';
          }
        } else {
          tmp = input;
        }
      } else if (input.length === 8) {
        // YYYY
        if (y4Flag) {
          tmp = input;
        } else {
          YYYY = input.slice(sIdx, sIdx + 4);
          tmp = input.slice(0, sIdx) + YYYY.slice(2) + input.slice(sIdx + 4);
        }
      } else {
        return '';
      }
      return this.textToYmd(tmp, inputFormat);
    },

    setDefaultDate() {
      if (this.isRange) {
        this.to.textInput = this.ymdToInput(this.to.actualDate);
        if (this.$refs['to-text']) {
          this.$refs['to-text'].blur();
        }
      }
      this.from.textInput = this.ymdToInput(this.from.actualDate);
      if (this.$refs['from-text']) {
        this.$refs['from-text'].blur();
      }
      this.showFlag = 0;
    },
    onUpdate(idx, tabEvent = DUMMY_EVENT) {
      if (tabEvent.shiftKey) {
        if (idx === 1) this.from.textInput = this.ymdToInput(this.from.actualDate);

        this.showFlag = 0;
        return;
      }
      // textInput is updated
      let tmp,
        rtn = ['', ''],
        newValue;
      if (this.isRange && idx === 1) {
        // range date picker && on update 'from' text
        newValue = this.inputToYmd(this.from.textInput);
        if (newValue !== '') {
          newValue = this.toValidYmd(newValue);
          // proper input received
          this.from.textInput = this.ymdToInput(newValue);
          this.from.selected = newValue;
          tmp = this.from.selected.split('-');
          this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
          this.$refs['to-text'].focus();
          tabEvent.preventDefault();
          return;
        }
        if (this.from.textInput) {
          // intend to input some date text but not valid -> restore text same as actualDate
          this.from.textInput = this.ymdToInput(this.from.actualDate);
          tabEvent.preventDefault();
          return;
        }
        if (!this.strictRange) {
          // empty input but want to enter 'to' date first. (only when strictRange false)
          // strictRange true -> not allow to input 'to' date before 'from' date confirmed.
          this.from.selected = '';
          this.$refs['to-text'].focus();
          tabEvent.preventDefault();
          return;
        }
        // strictRange true
        if (!this.isEqualArray(rtn, [this.from.selected, this.to.selected])) {
          // when strictRange true, empty input make selected date clear.
          this.from.selected = '';
          this.to.selected = '';
          tabEvent.preventDefault();
          return;
        }
        // already clear, update v-model & close calendar
        this.onConfirm();
      } else if (!this.isRange) {
        // single date picker
        newValue = this.inputToYmd(this.validateInputDate(this.from.textInput));
        if (newValue !== '') {
          newValue = this.toValidYmd(newValue);
          // proper input received
          if (newValue !== this.from.selected) {
            // change selected date same as input
            this.from.textInput = this.ymdToInput(newValue);
            this.from.selected = newValue;
            tmp = this.from.selected.split('-');
            this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
            tabEvent.preventDefault();
            if (this.$refs['from-text']) {
              this.$refs['from-text'].blur();
            }
            this.onConfirm();
            return;
          }
          // if selected date is already set ( equal actual date value), not need to update v-model & close calendar
          this.setDefaultDate();
          tabEvent.preventDefault();
          return; // not execute e.preventDefault
        } else if (this.from.textInput) {
          // intend to input some date text but not valid -> restore text same as actualDate
          this.from.textInput = this.ymdToInput(this.from.actualDate);
          tabEvent.preventDefault();
          return;
        } else if (this.from.selected) {
          // if selected date empty, check current date and set old date value if date is required
          if (this.requiredDateValue) this.setDefaultDate();
          else this.from.selected = '';
          tabEvent.preventDefault();
          return;
        }
        // already clear, update v-model & close calendar
        this.onConfirm();
      } else {
        // idx = 2
        // range date picker && on update 'to' text
        newValue = this.inputToYmd(this.validateInputDate(this.to.textInput));
        newValue = this.toValidYmd(newValue);
        if (newValue !== '' && this.strictRange) {
          // proper input received & strictRange true
          if (!this.from.selected) {
            // strictRange true -> not allow to input 'to' date before 'from' date confirmed.
            this.$refs['from-text'].focus();
            tabEvent.preventDefault();
            return;
          }
          if (this.from.selected > newValue) {
            // 'to' date input is earlier than 'from' date -> update 'from' date as received input.
            this.from.textInput = this.ymdToInput(newValue);
            this.from.selected = newValue;
            tmp = this.from.selected.split('-');
            this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
            this.to.textInput = '';
            this.to.selected = '';
            tabEvent.preventDefault();
            return;
          }
          if (newValue !== this.to.selected) {
            // update selected 'to' date as received input.
            this.to.textInput = this.ymdToInput(newValue);
            this.to.selected = newValue;
            tmp = this.to.selected.split('-');

            if (!this.isEqualArray(this.calendarMonth, [parseInt(tmp[0]), parseInt(tmp[1])])) {
              tmp = this.dateToYmd(this.ymdToDate(this.to.selected, 0, 0, 0)).split('-');
              this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
            }
            tabEvent.preventDefault();
            return;
          }
          // selected date already updated, update v-model & close calendar
          this.onConfirm();
          return; // not execute e.preventDefault
        } else if (newValue !== '' && newValue !== this.to.selected) {
          // proper input received & strictRange false -> make selected 'to' date as received input
          this.to.textInput = this.ymdToInput(newValue);
          this.to.selected = newValue;
          tmp = this.to.selected.split('-');
          if (!this.isEqualArray(this.calendarMonth, [parseInt(tmp[0]), parseInt(tmp[1])])) {
            tmp = this.dateToYmd(this.ymdToDate(this.to.selected, 0, 0, 0)).split('-');
            this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
          }
          tabEvent.preventDefault();
          this.onConfirm();
          return;
        } else if (newValue !== '') {
          // proper input received & strictRange false & selected 'to' date already updated
          // -> update v-model & close calendar
          this.onConfirm();
          return; // not execute e.preventDefault
        } else if (this.to.textInput) {
          // intend to input some date text but not valid -> restore text same as actualDate
          this.to.textInput = this.ymdToInput(this.to.actualDate);
          tabEvent.preventDefault();
          return;
        } else if (this.strictRange || this.to.selected) {
          // empty input recieved -> clear selected 'to' date
          this.to.selected = '';
          tabEvent.preventDefault();
          this.onConfirm();
          return;
        }
        // selected 'to' date already cleared & strictRange is false -> update v-model & close calendar
        this.onConfirm(); // not execute e.preventDefault
      }
    },

    ymdToText(val, textFormat) {
      let tmp, rtn;
      // valid val?
      if (!val || typeof val !== 'string') {
        return '';
      }
      tmp = val.split('-');
      if (tmp.length !== 3) {
        return '';
      }
      rtn = textFormat.toUpperCase();
      rtn = rtn.replace('YYYY', tmp[0]);
      rtn = rtn.replace('YY', tmp[0].slice(2));
      rtn = rtn.replace('MM', tmp[1]);
      rtn = rtn.replace('DD', tmp[2]);
      return rtn;
    },

    onClickDate(date) {
      if (date.state === 'prev') {
        this.onClickPrevMonth();
      } else if (date.state === 'next') {
        this.onClickNextMonth();
      }

      if (this.showFlag === 1) {
        this.from.textInput = this.ymdToInput(date.value);
        this.from.selected = date.value;

        this.onConfirm();
        if (this.isRange) {
          this.showFlag = 2;
        }
      } else if (this.showFlag === 2) {
        if (this.from.selected && this.to.selected) {
          this.to.textInput = '';
          this.to.selected = '';
          this.to.textInput = this.ymdToInput(date.value);
          this.to.selected = date.value;
        } else if (this.from.selected) {
          if (date.value < this.from.selected) {
            this.from.textInput = this.ymdToInput(date.value);
            this.from.selected = date.value;
          } else {
            this.to.textInput = this.ymdToInput(date.value);
            this.to.selected = date.value;
          }
        } else if (this.to.selected) {
          if (this.to.selected < date.value) {
            this.to.textInput = this.ymdToInput(date.value);
            this.to.selected = date.value;
          } else {
            this.from.textInput = this.ymdToInput(date.value);
            this.from.selected = date.value;
          }
        } else {
          this.to.textInput = this.ymdToInput(date.value);
          this.to.selected = date.value;
        }
        this.onConfirm();
      }
      this.isDateSelected = false;
    },

    onConfirm() {
      // selected confirmed and want to be update v-model & actual date
      // close calendar
      let rtn;
      if (this.isRange) {
        rtn = [this.ymdToModel(this.from.selected), this.ymdToModel(this.to.selected)];
        if (!this.isEqualArray(this.modelValue, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else {
          this.validateOnEvent();
        }
      } else {
        rtn = this.ymdToModel(this.from.selected);
        if (!this.isEqualModel(this.modelValue, rtn)) {
          this.$emit('update:modelValue', rtn);
        } else {
          this.validateOnEvent();
        }
      }
      this.showFlag = 0;
    },

    setCalendarMonth(calendarMonth) {
      let YYYY, MM;
      if (Array.isArray(calendarMonth) && calendarMonth.length === 2) {
        this.calendarMonth = [];
        YYYY = parseInt(calendarMonth[0]);
        MM = parseInt(calendarMonth[1]);
        if (MM < 1) {
          YYYY -= 1;
          MM += 12;
        }
        if (MM > 12) {
          YYYY += 1;
          MM -= 12;
        }
        this.calendarMonth.push(YYYY);
        this.calendarMonth.push(MM);
      }
    },

    onClickOutside() {
      if (this.showFlag === 0) {
        return;
      }
      // set selected back to original value
      // close calendar
      let tmp;
      if (this.isRange) {
        this.from.textInput = this.ymdToInput(this.from.actualDate);
        this.from.selected = this.from.actualDate;
        // this.to.textInput = this.ymdToInput(this.to.actualDate);
        // this.to.selected = this.from.actualDate;
        if (this.to.actualDate) {
          tmp = this.to.actualDate.split('-');
          tmp[1] = parseInt(tmp[1]);
        } else if (this.from.actualDate) {
          tmp = this.from.actualDate.split('-');
        } else {
          tmp = this.today.split('-');
        }
        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
      } else {
        this.from.textInput = this.ymdToInput(this.from.actualDate);
        this.from.selected = this.from.actualDate;
        if (this.from.actualDate) {
          tmp = this.from.actualDate.split('-');
        } else {
          tmp = this.today.split('-');
        }
        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
      }
      this.showFlag = 0;
      if (this.$refs['from-text']) {
        this.$refs['from-text'].blur();
      }
      if (this.$refs['to-text']) {
        this.$refs['to-text'].blur();
      }
      if (window.getSelection()) {
        window.getSelection().removeAllRanges();
      }
    },

    onClickPrevMonth() {
      if (this.viewMode === 'year') {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]) - 1,
          parseInt(this.calendarMonth[1])
        ]);
      } else if (this.viewMode === 'month') {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]) - 1,
          parseInt(this.calendarMonth[1])
        ]);
      } else {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]),
          parseInt(this.calendarMonth[1]) - 1
        ]);
      }
    },

    onClickNextMonth() {
      if (this.viewMode === 'year') {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]) + 1,
          parseInt(this.calendarMonth[1])
        ]);
      } else if (this.viewMode === 'month') {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]) + 1,
          parseInt(this.calendarMonth[1])
        ]);
      } else {
        this.setCalendarMonth([
          parseInt(this.calendarMonth[0]),
          parseInt(this.calendarMonth[1]) + 1
        ]);
      }
    },

    monthFilter(month, flag) {
      let m = parseInt(month[1]) - 2 + flag;
      let y = parseInt(month[0]);
      if (m < 0) {
        m = m + 12;
        y = y - 1;
      } else if (m > 11) {
        m = m - 12;
        y = y + 1;
      }
      m = m < 0 ? m + 12 : m > 11 ? m - 12 : m;
      return this.viewMode === 'day' ? this.monthAbbr[m] + ' ' + y : y;
    },

    decadeCalendar(calendarMonth) {
      let rtn = [],
        tmp = [];
      let yStr = String(calendarMonth[0]);
      let yyFrom = Number(yStr.slice(0, 3) + '0');
      let len = 10;

      for (let a = 0; a < len; a++) {
        tmp.push(yyFrom + a);
        if (a % 3 == 2) {
          rtn.push(tmp);
          tmp = [];
        }
      }
      if (tmp.length) {
        rtn.push(tmp);
      }
      return rtn;
    },

    yearCalendar() {
      return [
        [1, 2, 3],
        [4, 5, 6],
        [7, 8, 9],
        [10, 11, 12]
      ];
    },

    monthClass(month) {
      let rtn = [];
      rtn.push('lego-date-picker__calendar__month');
      if (month === this.calendarMonth[1]) rtn.push('lego-date-picker__calendar__month--selected');
      if (month === this.hoverMonth) rtn.push('lego-date-picker__calendar__month--hover');
      return rtn;
    },

    yearClass(year) {
      let rtn = [];
      rtn.push('lego-date-picker__calendar__year');
      if (year === this.calendarMonth[0]) rtn.push('lego-date-picker__calendar__year--selected');
      if (year === this.hoverYear) rtn.push('lego-date-picker__calendar__year--hover');
      return rtn;
    },

    modeChange(val) {
      this.viewMode = val;
    },

    onClickMonth(month) {
      if (this.month) {
        if (this.showFlag === 1) {
          this.from.selected = `${this.calendarMonth[0]}-${
            parseInt(month) < 10 ? `0${month}` : month
          }-01`;
          this.onConfirm();

          if (this.isRange) {
            this.showFlag = 2;
          }
        } else if (this.showFlag === 2) {
          this.to.selected = `${this.calendarMonth[0]}-${
            parseInt(month) < 10 ? `0${month}` : month
          }-01`;
          this.onConfirm();
        }
      } else {
        this.modeChange('day');
      }
      this.calendarMonth[1] = month;
      this.setCalendarMonth([parseInt(this.calendarMonth[0]), parseInt(this.calendarMonth[1])]);
      this.month || this.modeChange('day');
    },

    onClickYear(year) {
      if (this.year) {
        if (this.showFlag === 1) {
          this.from.selected = `${year}-01-01`;
          this.onConfirm();
          if (this.month) {
            this.modeChange('month');
          }
          if (this.isRange) {
            this.showFlag = 2;
          }
        } else if (this.showFlag === 2) {
          this.to.selected = `${year}-01-01`;
          this.onConfirm();
        }
      } else {
        this.month ? this.modeChange('month') : this.modeChange('day');
      }
      this.calendarMonth[0] = year;
      this.setCalendarMonth([parseInt(this.calendarMonth[0]), parseInt(this.calendarMonth[1])]);
    },

    validateInputDate(input) {
      const regex = /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/;
      if (regex.test(input) && input.length === 8) {
        return input;
      }
      let date = input.replace(/^(\d{4})(\d{0,2})(\d{0,2})$/, (match, year, month, day) => {
        month = month.padStart(2, '0');
        day = day.padStart(2, '0');
        return `${year}${month}${day}`;
      });
      return date;
    },

    validateFromInput() {
      if (this.isDateSelected) return;
      let newDate = this.convertDate(this.from.textInput);
      let rtn;
      if (!newDate && this.requiredDateValue) newDate = this.from.actualDate;
      if (this.isRange) rtn = [this.ymdToModel(newDate), this.ymdToModel(this.to.selected)];
      else rtn = this.ymdToModel(newDate);
      this.from.textInput = this.ymdToInput(newDate);
      this.isSetCalender = false;
      this.$emit('update:modelValue', rtn);
      return true;
    },
    validateToInput() {
      if (this.isDateSelected) return;
      let newDate = this.convertDate(this.to.textInput);
      if (!newDate && this.requiredDateValue) newDate = this.to.actualDate;
      if (newDate) {
        const validVal = this.toValidRange([this.from.selected, newDate]);
        if (!this.isValidRange(this.from.selected, newDate)) {
          newDate = validVal[1];
        }
      }
      if (this.isRange) {
        const rtn = [this.ymdToModel(this.from.selected), this.ymdToModel(newDate)];
        this.to.textInput = this.ymdToInput(newDate);
        this.isSetCalender = false;
        this.$emit('update:modelValue', rtn);
      }
      return true;
    },
    convertDate(newInput) {
      let newDate = this.inputToYmd(this.validateInputDate(newInput));
      newDate = this.toValidYmd(newDate);
      return newDate.split(' ')[0];
    },
    isValidRange(from, to) {
      return from <= to;
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin lego-date-picker-calendar {
  &__calendar {
    &__date {
      @include font(14px);
    }
  }
  padding: 12px;
  width: 244px;
  top: 32px;
  &__row-content {
    span {
      @include font(12px, 700);
      color: $color--ui01;

      &.lego-date-picker__calendar__date.lego-date-picker__calendar__date--other-month,
      &.lego-date-picker__calendar__date.lego-date-picker__calendar__date--disabled {
        opacity: 0.2;
      }

      &.lego-date-picker__calendar__date--sunday {
        color: $color--status-error;
      }

      &.lego-date-picker__calendar__date {
        @include font(12px, 400);
      }

      &.lego-date-picker__calendar__date--today {
        color: $color--primary;
      }

      &.lego-date-picker__calendar__date--selected {
        color: $color--ui-white;
        @include font(12px, 700);
      }
    }
  }
  &__date {
    &-area {
      flex: 0 0 220px;
      margin-bottom: 0px;
    }
  }

  &__month__row {
    position: relative;
    height: 48px;
    width: 100%;
    margin-bottom: 8px;
    padding: 0 12px;
  }

  &__month__row-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    float: left;

    span {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      flex: 0 0 auto;
      border-radius: 50%;
      margin: 0 12px;
      @include font(14px);
    }
  }

  &__month {
    cursor: pointer;

    &:hover {
      color: $lego__font-color--default;
      background-color: $color--ui-10;
    }

    &.lego-date-picker__calendar__month--selected {
      color: $color--ui-white;
      background-color: $color--primary;
    }
  }

  &__year__row {
    position: relative;
    height: 48px;
    width: 100%;
    margin-bottom: 16px;
  }

  &__year__row-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    float: left;

    span {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      flex: 0 0 auto;
      border-radius: 50%;
      margin: 0 12px;
      outline: none;
      @include font(13px);
    }
  }

  &__year {
    cursor: pointer;

    &:hover {
      color: $lego__font-color--default;
      background-color: $color--ui-10;
    }

    &.lego-date-picker__calendar__year--selected {
      color: $color--ui-white;
      background-color: $color--primary;
    }
  }
}

.lego-date-picker {
  &__calendar--range {
    .lego-date-picker__calendar__month-area {
      justify-content: space-between;
    }

    left: 155px;
  }

  &-header {
    .lego-date-picker-type {
      @include font(16px, 700);
      color: $color--primary;

      &:hover {
        text-decoration: underline;
      }

      &:nth-of-type(2) {
        margin-left: 8px;
      }
    }
  }

  &-type {
    cursor: pointer;
  }

  &__text-field {
    width: 127px !important;
    min-width: 127px;
  }

  .lego-date-picker__calendar {
    @include lego-date-picker-calendar;
  }

  .lego-date-picker__icon-wrapper {
    border-left: 0;

    &.disabled-date__icon {
      pointer-events: none;
    }
  }

  &.lego-date-picker--medium {
    .lego-icon-wrapper {
      width: 30px;
      height: 30px;
    }
  }
}

:deep .lego-text-field__input {
  cursor: pointer;
}
</style>
